import { Directive, effect, ElementRef, inject, input, Renderer2 } from '@angular/core';

import { Subscription } from 'rxjs';

import { Task, Workflow } from '@models';
import { isAfter, isPast, isToday } from 'date-fns';
import { CacheService } from '@services/cache.service';

@Directive({ selector: '[vz-duedate-text-classes]' })
export class DuedateTextClassesDirective {

    readonly task          = input<Task>(undefined, { alias: 'vz-duedate-text-classes' });

    dueToday: boolean = false;
    dueExpired: boolean = false;
    subscription?: Subscription;

    private readonly _cache = inject(CacheService);
    private readonly _el    = inject(ElementRef);
    private readonly _r2    = inject(Renderer2);

    private _1 = effect(() => {
        const t = this.task();
        if (!t) {
            return;
        }
        const el = this._el.nativeElement;
        this._r2.removeClass(el, 'f-txt-warn');
        this._r2.removeClass(el, 'f-txt-err');

        if (t.workflowId && t.dueDate) {
            if (this.subscription && !this.subscription.closed) {
                this.subscription.unsubscribe();
                this.subscription = undefined;
            }
            this.subscription = this._cache.get('workflow', t.workflowId).subscribe({
                next: st => {
                    const wf = st.item as Workflow;
                    const finished = wf?.finishStateId == t.stateId;
                    this.dueExpired = false;
                    this.dueToday = false;
                    if (t && t.dueDate) {
                        if ((t.archived || finished) && t.stateStartTime) {
                            this.dueExpired = t.dueDate && isPast(t.dueDate) && !isToday(t.dueDate) && isAfter(t.stateStartTime, t.dueDate);
                        }
                        else {
                            this.dueExpired = !!t.dueDate && isPast(t.dueDate);
                            this.dueToday = !!t.dueDate && isToday(t.dueDate);
                        }
                    }
                    if (this.dueExpired && !this.dueToday) {
                        this._r2.addClass(el, 'f-txt-err');
                    }
                    if (this.dueToday && !finished) {
                        this._r2.addClass(el, 'f-txt-warn');
                    }
                },
                error: () => {}
            });
        }
        else if (this.subscription && !this.subscription.closed) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }

    });

}
